import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';

@Component({
  selector: 'register-device',
  templateUrl: './register-device.component.html',
  styleUrls: ['./register-device.component.scss']
})
export class RegisterDeviceComponent implements OnInit {

  constructor(private router: Router) { }

  routing(route: string){
    this.router.navigate([route]);
  }

  ngOnInit() {
  }

}
